<template>
  <div class="pft-date-range" :style="style">{{ startDay }}至{{ endDay }}</div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue"
import moment from "moment"

interface ComponentProps {
  dayType:
    | "today"
    | "yesterday"
    | "thisWeek"
    | "thisMonth"
    | "lastMonth"
    | "lastWeek"
    | "thisQuarter"
    | "thisYear"
    | "latestnDays"
    | "latestnWeeks"
    | "latestnMonths"
    | "pastnDays"
    | "futurenDays"
  style?: { [key: string]: string }
  n?: number
}

const props = withDefaults(defineProps<ComponentProps>(), {
  dayType: () => "pastnDays",
  style: () => ({}),
  n: () => 30,
})

const startDay = ref<string>("")
const endDay = ref<string>("")

const dayType = props.dayType
const n = props.n
let start = moment()
let end = moment()
switch (dayType) {
  case "today":
    start = moment().startOf("day")
    end = moment().endOf("day")
    break
  case "yesterday":
    start = moment().subtract(1, "days").startOf("day")
    end = moment().subtract(1, "days").endOf("day")
    break
  case "thisWeek":
    start = moment().startOf("week")
    end = moment().endOf("week")
    break
  case "thisMonth":
    start = moment().startOf("month")
    end = moment().endOf("month")
    break
  case "lastMonth":
    start = moment().subtract(1, "months").startOf("month")
    end = moment().subtract(1, "months").endOf("month")
    break
  case "lastWeek":
    start = moment().subtract(1, "weeks").startOf("week")
    end = moment().subtract(1, "weeks").endOf("week")
    break
  case "thisQuarter":
    start = moment().startOf("quarter")
    end = moment().endOf("quarter")
    break
  case "thisYear":
    start = moment().startOf("year")
    end = moment().endOf("year")
    break
  case "latestnDays":
    start = moment().subtract(n, "days").startOf("day")
    end = moment().endOf("day")
    break
  case "latestnWeeks":
    start = moment().subtract(n, "weeks").startOf("week")
    end = moment().endOf("week")
    break
  case "latestnMonths":
    start = moment().subtract(n, "months").startOf("month")
    end = moment().endOf("month")
    break
  case "pastnDays":
    start = moment().subtract(n, "days").startOf("day")
    end = moment().subtract(1, "days").endOf("day")
    break
  case "futurenDays":
    start = moment().startOf("day")
    end = moment().add(n, "days").endOf("day")
    break
}
startDay.value = start.format("YYYY-MM-DD")
endDay.value = end.format("YYYY-MM-DD")
</script>

<style lang="scss">
.pft-date-range {
  font-family:
    Segoe UI,
    Segoe UI;
  font-weight: 400;
  font-size: 14px;
  color: rgba(43, 183, 247, 0.5);
  line-height: 20px;
}
</style>
